var map = {
	"./ConstructionHub.svg": 5634,
	"./ORBIS_dark.svg": 8832,
	"./ORBIS_light.svg": 688,
	"Images/Logos/ConstructionHub.svg": 5634,
	"Images/Logos/ORBIS_dark.svg": 8832,
	"Images/Logos/ORBIS_light.svg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5850;